import { Steps } from "antd";
import "./steper.scss";
const Steper = ({ items = [], currrent = 0 }) => {
  return (
    <>
      <Steps className="steper" size="small" current={currrent} items={items} />
    </>
  );
};

export default Steper;
